import { useNotificationState } from '@xstudios/xapp-core/foundation'

import { useQuickBooksStore } from '@/domains/integrations/quickbooks/stores/quickBooksStore'

export function handleQuickBooksAuthRequestError({
  code,
  detail,
  message,
  status,
}) {
  if (!isQuickBooksReauthError({ code, message, status })) {
    return false
  }

  const quickBooksStore = useQuickBooksStore()
  const reconnectMessage = String(
    detail?.message ||
      detail ||
      'QuickBooks session expired. Reconnect required.'
  )
  quickBooksStore.markReconnectRequired({
    authUrl: detail?.auth_url,
    message: reconnectMessage,
  })

  const { notify } = useNotificationState()
  notify({
    color: 'warning',
    text: reconnectMessage,
    title: 'QuickBooks',
  })
  return true
}

function isQuickBooksReauthError({ code, message, status }) {
  if (Number(status) !== 401) return false
  const normalizedCode = String(code || '').trim()
  const normalizedMessage = String(message || '').toLowerCase()
  return (
    normalizedCode === 'QB_REAUTH_REQUIRED' ||
    (normalizedMessage.includes('quickbooks') &&
      normalizedMessage.includes('reconnect'))
  )
}
